import { cn } from "@/lib/utils";

export function HudPanel({ title, icon: Icon, right, children, className, testId, accent = "cyan" }) {
  const border = accent === "amber" ? "border-jarvis-amber/25" : "border-jarvis-cyan/15";
  const titleColor = accent === "amber" ? "text-jarvis-amber" : "text-jarvis-cyanBright";
  return (
    <div className={cn("jv-panel hud-chamfer hud-bracket", className)} data-testid={testId}>
      <div className={cn("flex items-center justify-between pl-3.5 pr-3 py-2 border-b bg-jarvis-cyan/[0.03]", border)}>
        <div className="flex items-center gap-2 min-w-0">
          {Icon && <Icon className={cn("w-4 h-4 shrink-0", accent === "amber" ? "text-jarvis-amber" : "text-jarvis-cyan")} />}
          <h3 className={cn("font-brand text-[11px] font-semibold uppercase tracking-[0.14em] truncate", titleColor)}>{title}</h3>
        </div>
        {right}
      </div>
      <div className="p-3">{children}</div>
    </div>
  );
}

export function PreviewTag() {
  return (
    <span className="font-mono text-[8px] uppercase tracking-wider px-1.5 py-0.5 rounded border border-slate-600/60 text-slate-500" title="Sample / not a live source">
      preview
    </span>
  );
}
